import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// cart product count
export const getCategoriesFullData = createAsyncThunk(
  "get-category-details",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log("data", data);

    try {
      const response = await axios.get(
        `${baseUrl}vancouverapis/webapp/category/api/v1/get-category-details`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("getCategoriesFullData ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error getCategoriesFullData:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "getCategoriesFullData"
      );
    }
  }
);
